import React from 'react'
import subnavigation from './SubNavigation'
import PropTypes from 'prop-types'

function SubArrow(props) {
  if (props.subs) {
    return (
      <i className="icon-arrow-down navbar-subnav-indicator"></i>
    )
  } else {
    return null
  }
}

function Icon(props) {
  if (props.iconClass) {
    return (
      <i className={props.iconClass}></i>
    )
  } else {
    return null
  }
}

function DropDownNav(props) {
  const Nav = subnavigation(props.component)
  return (
    <Nav id={props.id} dropdown={props.dropdown} {...props} />
  )
}

function ProfileItem(props) {
  const profileImage = props.imgSrc !== ''
    ? <img
      alt={props.imgAlt}
      className={`avatar navbar-icon-profile ${props.className}`}
      height="24"
      src={props.imgSrc}
      width="24" />
    : null

  return (
    <span>
      {profileImage}
      <span className="navbar-icon-title">
        {props.username}
      </span>
    </span>
  )
}

module.exports = {
  DropDownNav,
  SubArrow,
  Icon,
  ProfileItem
}

DropDownNav.propTypes = {
  component: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  dropdown: PropTypes.string
}

ProfileItem.propTypes = {
  imgAlt: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  username: PropTypes.string
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/NavigationComponents.jsx